var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Sidebar',[_c('DividedSidebarList',{attrs:{"data-testid":"meeting-documents","list-item":_vm.MeetingDocumentListItem,"items":_vm.meetingDocuments,"title":"Zurück zur Sitzung","subtitle":_vm.meetingDocument.meeting.title,"parent":_vm.meetingDocument.meeting}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }